import React, {FC} from 'react';

interface IType {
    isSimple?: boolean
}


export const ProfileIcon: FC<IType> = ({isSimple}) => {
    return (
        <>
            {
                isSimple ?
                    <svg width="13" height="14" viewBox="0 0 13 14" fill="none" xmlns="http://www.w3.org/2000/svg">
                        <g clipPath="url(#clip0_67_2055)">
                            <path
                                d="M6.5 7C7.48509 7 8.42983 6.63125 9.1264 5.97487C9.82296 5.3185 10.2143 4.42826 10.2143 3.5C10.2143 2.57174 9.82296 1.6815 9.1264 1.02513C8.42983 0.368749 7.48509 0 6.5 0C5.51491 0 4.57017 0.368749 3.8736 1.02513C3.17704 1.6815 2.78571 2.57174 2.78571 3.5C2.78571 4.42826 3.17704 5.3185 3.8736 5.97487C4.57017 6.63125 5.51491 7 6.5 7ZM5.17388 8.3125C2.31562 8.3125 0 10.4945 0 13.1879C0 13.6363 0.385938 14 0.86183 14H12.1382C12.6141 14 13 13.6363 13 13.1879C13 10.4945 10.6844 8.3125 7.82612 8.3125H5.17388Z"
                                />
                        </g>
                        <defs>
                            <clipPath id="clip0_67_2055">
                                <rect width="13" height="14" fill="white"/>
                            </clipPath>
                        </defs>
                    </svg>
                    :
                    <svg width="21" height="24" viewBox="0 0 21 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                        <path
                            d="M10.5 12C12.0913 12 13.6174 11.3679 14.7426 10.2426C15.8679 9.11742 16.5 7.5913 16.5 6C16.5 4.4087 15.8679 2.88258 14.7426 1.75736C13.6174 0.632141 12.0913 0 10.5 0C8.9087 0 7.38258 0.632141 6.25736 1.75736C5.13214 2.88258 4.5 4.4087 4.5 6C4.5 7.5913 5.13214 9.11742 6.25736 10.2426C7.38258 11.3679 8.9087 12 10.5 12ZM8.35781 14.25C3.74063 14.25 0 17.9906 0 22.6078C0 23.3766 0.623438 24 1.39219 24H19.6078C20.3766 24 21 23.3766 21 22.6078C21 17.9906 17.2594 14.25 12.6422 14.25H8.35781Z"/>
                    </svg>

            }
        </>

    )
        ;
};

